import React, { Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";

import {
  Label,
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  Button,
  Tooltip,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";
import Select from "react-select";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import moment from "moment";
import { count } from "rxjs";
import LoadingComponent from "./Components/LoadingComponent";

// var reformatEmployee = function (employee) {
//   return employee.map(function (region) {
//     var newObj = {};
//     newObj["label"] = region.employee_nip + " - " + region.employee_full_name;
//     newObj["value"] = region.employee_uuid;
//     newObj["model"] = region;
//     return newObj;
//   });
// };

// var reformatRank = function (ranks) {
//   return ranks.map(function (rank) {
//     var newObj = {};
//     newObj["label"] = rank.rank_name + " - " + rank.rank_group_room;
//     newObj["value"] = rank.rank_uuid;
//     newObj["model"] = rank;
//     return newObj;
//   });
// };
// var reformatOptionPosition = function (option) {
//   return option.map(function (opsi) {
//     var newObj = {};
//     newObj["label"] = opsi.position_name;
//     newObj["value"] = opsi.position_uuid;

//     return newObj;
//   });
// };
// var reformatType = function (regions) {
//   return regions.map(function (region) {
//     var newObj = {};
//     newObj["label"] = region.retired_type_name;
//     newObj["value"] = region.retired_type_uuid;
//     return newObj;
//   });
// };

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];
    newObj["model"] = data;

    return newObj;
  });
};
var reformatCriteria = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = data.assessment_criteria_name;
    newObj["tooltip"] = data.assessment_criteria_fullname;
    newObj["value"] = data.assessment_criteria_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

class IndexView extends Component {
  createBloc = new CreateBloc();
  queryParams = new URLSearchParams(window.location.search);
  userdata = JSON.parse(localStorage.getItem("userdata"));

  constructor(props) {
    super(props);
    this.state = {
      peg_uuid: "",
      isLoadingOptEmployee: true,
      is_koreksi_kehadiran: false,
      is_grade: false,
      is_dinas: false,
      is_cuti: false,
      listExclude: [],
      dataForm: {
        financial_revision_period_uuid: props.uuid,
      },
      employeeItems: [],
      rankItems: [],
      employeeSelected: props.pegawai_uuid,
      pangkatSelected: "",
      typeItems: [],
      typeSelected: "",
      rankGroupRoom: "",
      loadingTable: false,
      rows: [],
      cancelDate: null,
      result_type: null,
      confirmInfo: "",
      modal: false,
      modalSize: "sm",
      positionItems: [],
      PositionSelected: null,
      RankSelected: null,
      SendPositionSelected: null,
      SendRankSelected: null,
      GradeSelected: null,
      GenerateType: null,
      data_grade: [],
      data_periode: [],
      data_presensi: [],
      data_tunsus: [],
      loadingDetail: true,
      loadingGrade: true,
      loadingSkp: true,
      updateUuid: null,
      detailUuid: null,
      updateSkpUuid: null,
      detailSkpUuid: null,
      updatePenilaianUuid: null,
      detailPenilaianUuid: null,
      hasilperilakuOption: [
        { 'label': 'Di atas', 'value': 'Di atas' },
        { 'label': 'Sesuai', 'value': 'Sesuai' },
        { 'label': 'Di bawah', 'value': 'Di bawah' },
      ],
      optcriteria: [],
      listComponents: [],
      indexs: [],
      listCriteria: [],
      criteriaSelected: [],
    };
    this.setPosition = this.setPosition.bind(this);
    this.setPositionGrade = this.setPositionGrade.bind(this);
  }
  setPosition = (jenis) => {
    // console.log(jenis);
    // this.setState({
    // 	SendPositionSelected: e.value,
    // 	GradeSelected: e.target.value
    // });
    // this.SendSetPosition();
  };
  setPositionGrade = (e) => {
    this.setState({
      GradeSelected: e.target.value,
    });
    this.SendSetPosition();
  };

  cancelDate = async () => {
    const query = {
      uuid: this.props.uuid,
      date: this.state.cancelDate,
      result_type: this.state.result_type,
      pegawai_uuid: this.queryParams.get("employee_uuid"),
      pegawai_nip: this.state.data_summary.presensi_summary_employee_nip,
      period_financial_revision_uuid: this.props.uuid,
      revision_uuid: this.queryParams.get("revision_uuid"),
    };

    await this.createBloc.fetchDeletePresensi(query);
  };

  SendSetPosition = async (e) => {
    const query = {
      uuid: this.props.uuid,
      result_type: this.state.result_type,
      year: this.state.data_periode.period_financial_revision_year,
      month: this.state.data_periode.period_financial_revision_month,
      pegawai_uuid: this.queryParams.get("employee_uuid"),
      pegawai_nip: this.state.data_summary.presensi_summary_employee_nip,
      position_uuid: this.state.SendPositionSelected,
      grade: this.state.GradeSelected,
    };
    await this.createBloc.fetchUpdateJabatan(query);
  };

  fetchDetail = async () => {
    this.createBloc.fetchDetailPegawai({
      revision_period_uuid: this.queryParams.get("period_uuid"),
      pegawai_uuid: this.queryParams.get("employee_uuid"),
      pegawai_nip: this.queryParams.get("pegawai_nip"),
      revision_uuid: this.queryParams.get("revision_uuid"),
    });
  };

  updateGrade = async () => {
    const formData = generateFormData(this.state.dataForm); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.updateGrade(formData);
  };
  updateSkp = async () => {
    const formData = generateFormData(this.state.dataForm); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.updateSkp(formData);
  };
  updatePenilaian = async () => {
    const formData = generateFormData(this.state.dataForm); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.updatePenilaian(formData);
  };

  recalculation = async () => {
    await this.createBloc.recalculationRevision({
      revision_uuid: this.state.detailUuid,
    });
  };

  toggleModal = () => this.setState({ updateUuid: null, detailUuid: null });
  toggleModalSkp = () => this.setState({ updateSkpUuid: null, detailSkpUuid: null });
  toggleModalPenilaian = () => this.setState({ updatePenilaianUuid: null, detailPenilaianUuid: null });
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    // var list_pegawai_nip = [];
    // var list_pegawai_uuid = [];
    // var idx = 0;
    // this.state.listExclude.forEach((el) => {
    //   list_pegawai_nip[idx] = el.nip;
    //   list_pegawai_uuid[idx] = el.uuid;
    //   // console.log(el);
    //   idx++;
    // });
    // var peg_uuid = this.userdata != null ? this.userdata.employee_uuid : "";
    // debugger;
    this.setState({
      // dataForm: {
      //   financial_revision_period_uuid: this.queryParams.get("period_uuid"),
      //   financial_revision_employee_nip: list_pegawai_nip,
      //   financial_revision_employee_uuid: list_pegawai_uuid,
      //   peg_uuid: peg_uuid,
      //   ...values,
      // },
      // confirm: true,
      dataForm: {
        revision_uuid: this.state.updateUuid,
        ...values,
      },
      confirm: true,
    });
    //console.log(this.state.dataForm);
  };
  handlerOnSubmitSkp = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        revision_uuid: this.state.updateSkpUuid,
        ...values,
      },
      confirm: true,
    });
  };
  handlerOnSubmitPenilaian = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        revision_uuid: this.state.updatePenilaianUuid,
        special_uuid: this.state.data_tunsus.special_allowance_uuid,
        ...values,
      },
      confirm: true,
    });
  };
  handlerOnopenPenilaian = () => {
    // e.preventDefault();
    this.createBloc.fetchComponent({
      status: 1,
      uuid: this.state.data_tunsus.special_allowance_uuid,
    });
  };
  handleChangeParent = (indexParent, indexChild, val) => {
    // update parent selected
    this.handleChange(indexChild, val);
    // update child selected all
    if (val.target.value) {
      this.setState(
        (prevState) => {
          const updatedCriteriaSelected = [...prevState.criteriaSelected];
          const min = this.state.indexs[indexParent].min;
          const max = this.state.indexs[indexParent].max;
          for (let i = min; i <= max; i++) {
            updatedCriteriaSelected[i] = val.target.value;
          }
          return {
            criteriaSelected: updatedCriteriaSelected,
          };
        },
        () => {
          // console.log(this.state.criteriaSelected);
        }
      );
    }
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        if (this.state.submitType == 1) {
          this.updateGrade();
        }
        if (this.state.submitType == 2) {
          this.recalculation();
        }
        if (this.state.submitType == 3) {
          this.updateSkp();
        }
        if (this.state.submitType == 4) {
          this.updatePenilaian();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: false,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };
  penilaianHistory = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchComponentHistory({
      status: 1,
      uuid: queryParams.get("uuid"),
    });
  };

  handleChange = (index, val) => {
    if (val.target.value) {
      this.setState(
        (prevState) => {
          const updatedCriteriaSelected = [...prevState.criteriaSelected];
          updatedCriteriaSelected[index] = val.target.value;
          return {
            criteriaSelected: updatedCriteriaSelected,
          };
        },
        () => { }
      );
    }
  };

  componentDidMount() {
    this.createBloc.detailPegawaiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingDetail: true,
          });

        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              data_presensi: response.data_presensi,
              data_grade: response.data_grade,
              data_periode: response.data_periode,
              saldo: response.saldo,
              presensi: response.presensi,
              skp: response.skp,
              penilaian: response.penilaian,
              data_tunsus: response.data_tunsus,
              loadingDetail: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.gradeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingGrade: true,
          });

        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({
              gradeListOption: reformatOptions(
                result.data?.response?.result,
                "special_level_code",
                "special_level_uuid"
              ),
              loadingGrade: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.updateGradeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status === true) {
            this.setState({
              loading: false,
              loadingDetail: true,
              success: true,
              data_presensi: [],
              data_grade: [],
              data_periode: [],
              saldo: null,
            });
            this.fetchDetail();
          } else {
            this.setState({
              failedInfo: result.data.message,
              loading: false,
              failed: true,
            });
          }
          this.toggleModal();

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
    this.createBloc.updateSkpChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status === true) {
            this.setState({
              loading: false,
              loadingDetail: true,
              success: true,
              data_presensi: [],
              data_grade: [],
              data_periode: [],
              saldo: null,
            });
            this.fetchDetail();
          } else {
            this.setState({
              failedInfo: result.data.message,
              loading: false,
              failed: true,
            });
          }
          this.toggleModalSkp();

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
    this.createBloc.updatePenilaianChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status === true) {
            this.setState({
              loading: false,
              loadingDetail: true,
              success: true,
              data_presensi: [],
              data_grade: [],
              data_periode: [],
              data_tunsus: [],
              saldo: null,
            });
            this.fetchDetail();
          } else {
            this.setState({
              failedInfo: result.data.message,
              loading: false,
              failed: true,
            });
          }
          this.toggleModalPenilaian();

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.recalculationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({
              loading: false,
              loadingDetail: true,
              success: true,
            });
            this.fetchDetail();
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.fetchDetail();

    this.createBloc.individualCriteriaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response
            // console.log(response)
            this.setState({
              optcriteria: this.reformatOptions(
                response.result,
                'individual_assessment_criteria_name',
                'individual_assessment_criteria_value',
              ),
              isLoadingOptEmployee: false
            })
            console.log(this.state.optcriteria);
          }
          break
        case apiResponse.ERROR:

          break
        default:
          break
      }
    })
    this.createBloc.fetchIndividualCriteria()

    this.createBloc.listComponentChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            let components = response.result
              .filter((item) => item.assessment_component_type === 2)
              .map((item) => "component_" + item.assessment_component_uuid);
            this.setState({
              loading: false,
              // dokumen_persyaratan: response.result,
              components: components,
              // search_document: 2,
              loadingTable: false,
              listComponents: response.result,
              indexs: Object.values(response.index).map((item) => ({
                min: item.min,
                max: item.max,
              })),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.listComponentHistoryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingHistory: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingHistory: true,
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              criteriaSelected: response.list_assestment_history
                ? response.list_assestment_history.result
                : [],
              loadingHistory: false,
              loading: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.listCriteriaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingCriteria: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingCriteria: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              listCriteria: reformatCriteria(response.result),
              loadingCriteria: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchCriteria({ status: 1 });
  }

  componentWillUnmount() {
    this.createBloc.detailPegawaiChannel.unsubscribe();
    this.createBloc.listComponentChannel?.unsubscribe();
  }

  render() {
    var number = 0;
    return (
      <Fragment>
        <style>
          {`
            .custom-arrow::before {
              content: "";
              position: absolute;
              width: 0;
              height: 0;
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-right: 6px solid #000; /* Same color as tooltip background */
              top: 50%; /* Position arrow at the vertical center */
              left: -5px; /* Adjust position from the left */
              transform: translateY(-50%); /* Center the arrow vertically */
            }
          `}
        </style>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <div className="float-end"></div>
                  <CardTitle>Revisi Pegawai</CardTitle>

                  <hr />
                  {/* <AvForm
                      className="needs-validation"
                      onValidSubmit={(e, values) =>
                        this.handlerOnSubmit(e, values)
                      }
                    > */}
                  <Row className="mb-1">
                    <label className="col-md-2 col-form-label pt-0">
                      Periode
                    </label>
                    <Col md="10">
                      {this.state.loadingDetail === false ? (
                        <>
                          {this.state.data_periode
                            .period_special_allowance_revision_periode !== "" &&
                            this.state.data_periode
                              .period_special_allowance_revision_periode !== null
                            ? this.state.data_periode
                              .period_special_allowance_revision_periode
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-2 col-form-label pt-0">Nip</label>
                    <Col md="10">
                      {this.state.loadingDetail === false ? (
                        <>
                          {this.state.data_presensi
                            .special_allowance_summary_rev_employee_nip !==
                            "" &&
                            this.state.data_presensi
                              .special_allowance_summary_rev_employee_nip !== null
                            ? this.state.data_presensi
                              .special_allowance_summary_rev_employee_nip
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-2 col-form-label pt-0">Nama</label>
                    <Col md="10">
                      {this.state.loadingDetail === false ? (
                        <>
                          {this.state.data_presensi
                            .special_allowance_summary_rev_employee_full_name !==
                            "" &&
                            this.state.data_presensi
                              .special_allowance_summary_rev_employee_full_name !==
                            null
                            ? this.state.data_presensi
                              .special_allowance_summary_rev_employee_full_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-2 col-form-label pt-0">
                      Jabatan
                    </label>
                    <Col md="10">
                      {this.state.loadingDetail === false ? (
                        <>
                          {this.state.data_presensi
                            .current_position_name_new !== "" &&
                            this.state.data_presensi.current_position_name_new !==
                            null
                            ? this.state.data_presensi.current_position_name_new
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <hr />
                  <br></br>

                  {this.state.loadingDetail === true ? (
                    <>
                      <div
                        className="md-12 text-center"
                        style={{
                          alignItems: "center",
                          left: "50%",
                        }}
                      >
                        <Spinner className="text-center" color="primary" />
                        <div>Memuat Data</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <Table className="table table-striped table-bordered">
                          <thead className="table-primary">
                            <tr style={{ border: "1px solid #c8cce1" }}>
                              <th
                                className="text-left align-middle"
                                width="*"
                                colSpan="1"
                              >
                                Revisi Tunjanagn Khusus
                              </th>
                              <th
                                className="text-center align-middle table-warning"
                                style={{
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                                width="*"
                                colSpan="1"
                              >
                                Sebelum Revisi
                              </th>
                              <th
                                className="text-center align-middle table-success"
                                style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                                colSpan="1"
                              >
                                Setelah Revisi
                              </th>
                              <th
                                className="text-center align-middle "
                                // style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                                colSpan="1"
                              >
                                Aksi
                              </th>
                            </tr>

                            <tr style={{ border: "1px solid #c8cce1" }}>
                              <th
                                className="text-left align-middle table-warning"
                                // style={{ backgroundColor: "rgb(255, 250, 233)" }}
                                width="*"
                              >
                                Grade
                              </th>
                              <th
                                className="text-center align-middle table-warning"
                                style={{
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_emp_grade_tunsus
                                  : ""}
                              </th>

                              <th
                                className="text-center align-middle table-success"
                                style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_rev_emp_grade_tunsus
                                    ? this.state.data_presensi
                                      .special_allowance_summary_rev_emp_grade_tunsus
                                    : "-"
                                  : "-"}
                              </th>
                              <th
                                className="text-center align-middle table-success"
                                // style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                <span>
                                  <button
                                    className={`btn btn-${this.state.data_periode
                                      .period_special_allowance_revision_status ===
                                      0
                                      ? "warning"
                                      : "primary"
                                      } btn-sm`}
                                    id={"update-grade"}
                                    onClick={() => {
                                      this.setState({
                                        updateUuid:
                                          this.queryParams.get("revision_uuid"),
                                        submitType: 1,
                                        confirmInfo:
                                          "Apakah anda yakin akan menyimpan perubahan grade ini ?",
                                      });
                                      this.createBloc.fetchGrade();
                                    }}
                                    style={{
                                      marginRight: "2px",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <i
                                      className={
                                        this.state.data_periode
                                          .period_special_allowance_revision_status ==
                                          0
                                          ? "uil-pen"
                                          : "uil-file-alt"
                                      }
                                    ></i>
                                  </button>
                                  <Tooltip
                                    style={{
                                      marginBottom: 2,
                                    }}
                                    placement="top"
                                    isOpen={
                                      this.state[
                                      "update" +
                                      this.queryParams.get("revision_uuid")
                                      ]
                                    }
                                    target={"update-grade"}
                                    toggle={() => {
                                      this.setState({
                                        ["update" +
                                          this.queryParams.get("revision_uuid")]:
                                          !this.state[
                                          "update" +
                                          this.queryParams.get(
                                            "revision_uuid"
                                          )
                                          ],
                                      });
                                    }}
                                  >
                                    {this.state.data_periode
                                      .period_special_allowance_revision_status ==
                                      0
                                      ? "Ubah Grade"
                                      : "Lihat Detail"}
                                  </Tooltip>
                                </span>
                              </th>
                            </tr>

                            <tr style={{ border: "1px solid #c8cce1" }}>
                              <th
                                className="text-left align-middle table-warning"
                                // style={{ backgroundColor: "rgb(255, 250, 233)" }}
                                width="*"
                              >
                                Presensi (Bobot{" "}
                                {this.state.presensi ? this.state.presensi : ""}{" "}
                                %)
                              </th>
                              <th
                                className="text-center align-middle table-warning"
                                style={{
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_presensi
                                  : ""}
                              </th>

                              <th
                                className="text-center align-middle table-success"
                                style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_rev_presensi
                                    ? this.state.data_presensi
                                      .special_allowance_summary_rev_presensi
                                    : "-"
                                  : "-"}
                              </th>
                              <th
                                className="text-center align-middle table-success"
                                // style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                {this.state.data_periode
                                  .period_special_allowance_revision_status ==
                                  0 ? (
                                  <span>
                                    <button
                                      className="btn btn-success btn-sm"
                                      id={"recalculation"}
                                      onClick={() => {
                                        this.setState({
                                          detailUuid:
                                            this.queryParams.get(
                                              "revision_uuid"
                                            ),
                                          submitType: 2,
                                          confirmInfo:
                                            "Apakah anda yakin akan melakukan hitung ulang untuk data ini ?",
                                          confirm: true,
                                        });
                                      }}
                                      style={{
                                        marginRight: "2px",
                                        padding: "2px 5px",
                                      }}
                                    >
                                      <i className="uil-refresh"></i>
                                    </button>
                                    <Tooltip
                                      style={{
                                        marginBottom: 2,
                                      }}
                                      placement="top"
                                      isOpen={
                                        this.state[
                                        "recalculation" +
                                        this.queryParams.get(
                                          "revision_uuid"
                                        )
                                        ]
                                      }
                                      target={"recalculation"}
                                      toggle={() => {
                                        this.setState({
                                          ["recalculation" +
                                            this.queryParams.get(
                                              "revision_uuid"
                                            )]:
                                            !this.state[
                                            "recalculation" +
                                            this.queryParams.get(
                                              "revision_uuid"
                                            )
                                            ],
                                        });
                                      }}
                                    >
                                      Hitung Ulang
                                    </Tooltip>
                                  </span>
                                ) : null}
                              </th>
                            </tr>

                            <tr style={{ border: "1px solid #c8cce1" }}>
                              <th
                                className="text-left align-middle table-warning"
                                // style={{ backgroundColor: "rgb(255, 250, 233)" }}
                                width="*"
                              >
                                SKP (Bobot{" "}
                                {this.state.skp !== null ? this.state.skp : ""}{" "}
                                %)
                              </th>
                              <th
                                className="text-center align-middle table-warning"
                                style={{
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_skp
                                  : ""}
                              </th>

                              <th
                                className="text-center align-middle table-success"
                                style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_rev_skp
                                    ? this.state.data_presensi
                                      .special_allowance_summary_rev_skp
                                    : "-"
                                  : "-"}
                              </th>
                              <th
                                className="text-center align-middle table-success"
                                // style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                <span>
                                  <button
                                    className={`btn btn-${this.state.data_periode
                                      .period_special_allowance_revision_status ===
                                      0
                                      ? "warning"
                                      : "primary"
                                      } btn-sm`}
                                    id={"update-skp"}
                                    onClick={() => {
                                      this.setState({
                                        updateSkpUuid:
                                          this.queryParams.get("revision_uuid"),
                                        submitType: 3,
                                        confirmInfo:
                                          "Apakah anda yakin akan menyimpan perubahan SKP ini ?",
                                      });
                                      // this.createBloc.fetchGrade();
                                    }}
                                    style={{
                                      marginRight: "2px",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <i
                                      className={
                                        this.state.data_periode
                                          .period_special_allowance_revision_status ==
                                          0
                                          ? "uil-pen"
                                          : "uil-file-alt"
                                      }
                                    ></i>
                                  </button>
                                  <Tooltip
                                    style={{
                                      marginBottom: 2,
                                    }}
                                    placement="top"
                                    isOpen={
                                      this.state[
                                      "updateSkp" +
                                      this.queryParams.get("revision_uuid")
                                      ]
                                    }
                                    target={"update-skp"}
                                    toggle={() => {
                                      this.setState({
                                        ["updateSkp" +
                                          this.queryParams.get("revision_uuid")]:
                                          !this.state[
                                          "updateSkp" +
                                          this.queryParams.get(
                                            "revision_uuid"
                                          )
                                          ],
                                      });
                                    }}
                                  >
                                    {this.state.data_periode
                                      .period_special_allowance_revision_status ==
                                      0
                                      ? "Ubah SKP"
                                      : "Lihat Detail"}
                                  </Tooltip>
                                </span>
                              </th>
                            </tr>

                            <tr style={{ border: "1px solid #c8cce1" }}>
                              <th
                                className="text-left align-middle table-warning"
                                // style={{ backgroundColor: "rgb(255, 250, 233)" }}
                                width="*"
                              >
                                Penilaian Pimpinan (Bobot{" "}
                                {this.state.penilaian !== null
                                  ? this.state.penilaian
                                  : ""}{" "}
                                %)
                              </th>
                              <th
                                className="text-center align-middle table-warning"
                                style={{
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_penilaian_pimpinan
                                  : ""}
                              </th>

                              <th
                                className="text-center align-middle table-success"
                                style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_rev_penilaian_pimpinan
                                    ? this.state.data_presensi
                                      .special_allowance_summary_rev_penilaian_pimpinan
                                    : "-"
                                  : "-"}
                              </th>
                              <th
                                className="text-center align-middle table-success"
                                // style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                <span>
                                  <button
                                    className={`btn btn-${this.state.data_periode
                                      .period_special_allowance_revision_status ===
                                      0
                                      ? "warning"
                                      : "primary"
                                      } btn-sm`}
                                    id={"update-skp"}
                                    onClick={() => {
                                      this.setState({
                                        updatePenilaianUuid:
                                          this.queryParams.get("revision_uuid"),
                                        submitType: 4,
                                        confirmInfo:
                                          "Apakah anda yakin akan menyimpan perubahan Penilaian Pimpinan ini ?",
                                      });
                                      // this.createBloc.fetchGrade();
                                      this.handlerOnopenPenilaian();
                                    }}
                                    style={{
                                      marginRight: "2px",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <i
                                      className={
                                        this.state.data_periode
                                          .period_special_allowance_revision_status ==
                                          0
                                          ? "uil-pen"
                                          : "uil-file-alt"
                                      }
                                    ></i>
                                  </button>
                                  <Tooltip
                                    style={{
                                      marginBottom: 2,
                                    }}
                                    placement="top"
                                    isOpen={
                                      this.state[
                                      "updatePenilaian" +
                                      this.queryParams.get("revision_uuid")
                                      ]
                                    }
                                    target={"update-skp"}
                                    toggle={() => {
                                      this.setState({
                                        ["updatePenilaian" +
                                          this.queryParams.get("revision_uuid")]:
                                          !this.state[
                                          "updatePenilaian" +
                                          this.queryParams.get(
                                            "revision_uuid"
                                          )
                                          ],
                                      });
                                    }}
                                  >
                                    {this.state.data_periode
                                      .period_special_allowance_revision_status ==
                                      0
                                      ? "Ubah Penilaian Pimpinan"
                                      : "Lihat Detail"}
                                  </Tooltip>
                                </span>
                              </th>
                            </tr>

                            <tr style={{ border: "1px solid #c8cce1" }}>
                              <th
                                className="text-left align-middle table-warning"
                                // style={{ backgroundColor: "rgb(255, 250, 233)" }}
                                width="*"
                              >
                                Total Tunjangan Khusus
                              </th>
                              <th
                                className="text-center align-middle table-warning"
                                style={{
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_total
                                  : ""}
                              </th>

                              <th
                                className="text-center align-middle table-success"
                                style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              >
                                {this.state.data_presensi
                                  ? this.state.data_presensi
                                    .special_allowance_summary_rev_total
                                    ? this.state.data_presensi
                                      .special_allowance_summary_rev_total
                                    : "-"
                                  : "-"}
                              </th>
                              <th
                                className="text-center align-middle table-success"
                                // style={{ backgroundColor: "#e6ffe5" }}
                                width="*"
                              ></th>
                            </tr>
                          </thead>
                        </Table>
                      </div>
                    </>
                  )}

                  <Row className="mb-1">
                    {/* <Col md="2"></Col> */}
                    <Col md="12">
                      <Link
                        to={
                          `?employee&period_uuid=` +
                          this.queryParams.get("period_uuid")
                        }
                      >
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>{" "}
                    </Col>
                  </Row>
                  {/* </AvForm> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          size="lg"
          isOpen={this.state.updateUuid !== null ? true : false}
          toggle={() => this.toggleModal()}
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            {this.state.detailUuid != null ? "Detail" : "Ubah"} Grade
          </ModalHeader>
          <AvForm
            className="needs-validation"
            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
          >
            <ModalBody>
              {
                this.state.loading == true ? (
                  <Fragment>
                    <LoadingComponent message="Memeriksa Data Grade..." />
                  </Fragment>
                ) : (
                  <Fragment>
                    <Row className="mb-1">
                      <label className="col-md-3 col-form-label pt-0">
                        Periode
                      </label>
                      <Col md="9">
                        {this.state.data_periode ? (
                          <>
                            {this.state.data_periode
                              .period_special_allowance_revision_periode !== "" &&
                              this.state.data_periode
                                .period_special_allowance_revision_periode !== null
                              ? this.state.data_periode
                                .period_special_allowance_revision_periode
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "100%", height: "15px" }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <label className="col-md-3 col-form-label pt-0">Nip</label>
                      <Col md="9">
                        {this.state.data_presensi ? (
                          <>
                            {this.state.data_presensi
                              .special_allowance_summary_rev_employee_nip !==
                              "" &&
                              this.state.data_presensi
                                .special_allowance_summary_rev_employee_nip !== null
                              ? this.state.data_presensi
                                .special_allowance_summary_rev_employee_nip
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "100%", height: "15px" }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <label className="col-md-3 col-form-label pt-0">Nama</label>
                      <Col md="9">
                        {this.state.data_presensi ? (
                          <>
                            {this.state.data_presensi
                              .special_allowance_summary_rev_employee_full_name !==
                              "" &&
                              this.state.data_presensi
                                .special_allowance_summary_rev_employee_full_name !==
                              null
                              ? this.state.data_presensi
                                .special_allowance_summary_rev_employee_full_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "100%", height: "15px" }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <label className="col-md-3 col-form-label pt-0">
                        Jabatan
                      </label>
                      <Col md="9">
                        {this.state.data_presensi ? (
                          <>
                            {this.state.data_presensi
                              .current_position_name_new !== "" &&
                              this.state.data_presensi.current_position_name_new !==
                              null
                              ? this.state.data_presensi.current_position_name_new
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "100%", height: "15px" }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <label className="col-md-3 col-form-label pt-0">
                        Grade Sebelum
                      </label>
                      <Col md="9">
                        {this.state.data_presensi ? (
                          <>
                            {this.state.data_presensi
                              .special_allowance_summary_emp_grade_tunsus !==
                              "" &&
                              this.state.data_presensi
                                .special_allowance_summary_emp_grade_tunsus !== null
                              ? this.state.data_presensi
                                .special_allowance_summary_emp_grade_tunsus
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "100%", height: "15px" }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Grade Revisi <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <CustomSelect
                          name="special_allowance_summary_rev_level_uuid"
                          placeholder="Pilihan Grade Revisi..."
                          errorMessage="Pilihan Grade Revisi"
                          defaultValue={
                            this.state.data_presensi.special_allowance_summary_rev_level_uuid !== null && this.state.data_presensi.special_allowance_summary_rev_level_uuid !== null ? this.state.data_presensi.special_allowance_summary_rev_level_uuid : null
                          }
                          validate={{ required: { value: true } }}
                          options={this.state.gradeListOption}
                          isLoading={!this.state.gradeListOption?.length}
                          onChange={(v) =>
                            this.setState({
                              selectedGrade: v.value,
                              selectedGradeName: v.label,
                            })
                          }
                          isDisabled={
                            this.state.data_periode
                              .period_special_allowance_revision_status == 0
                              ? false
                              : true
                          }
                        />

                        <AvField
                          name="special_allowance_summary_rev_emp_grade_tunsus"
                          value={this.state.selectedGradeName}
                          type="hidden"
                        />
                      </Col>
                    </Row>
                  </Fragment>
                )}
            </ModalBody>
            {this.state.loadingDetail === false &&
              this.state.data_periode.period_special_allowance_revision_status ==
              0 ? (
              <ModalFooter>
                <Button color="primary" type="submit">
                  Submit
                </Button>{" "}
                <Button onClick={() => this.toggleModal()}>Cancel</Button>
              </ModalFooter>
            ) : null}
          </AvForm>
        </Modal>
        <Modal
          size="lg"
          isOpen={this.state.updateSkpUuid !== null ? true : false}
          toggle={() => this.toggleModalSkp()}
        >
          <ModalHeader toggle={() => this.toggleModalSkp()}>
            {this.state.detailSkpUuid != null ? "Detail" : "Ubah"} SKP
          </ModalHeader>
          <AvForm
            className="needs-validation"
            onValidSubmit={(e, values) => this.handlerOnSubmitSkp(e, values)}
          >
            <ModalBody>
              {(
                <Fragment>
                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">
                      Periode
                    </label>
                    <Col md="9">
                      {this.state.data_periode ? (
                        <>
                          {this.state.data_periode
                            .period_special_allowance_revision_periode !== "" &&
                            this.state.data_periode
                              .period_special_allowance_revision_periode !== null
                            ? this.state.data_periode
                              .period_special_allowance_revision_periode
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">Nip</label>
                    <Col md="9">
                      {this.state.data_presensi ? (
                        <>
                          {this.state.data_presensi
                            .special_allowance_summary_rev_employee_nip !==
                            "" &&
                            this.state.data_presensi
                              .special_allowance_summary_rev_employee_nip !== null
                            ? this.state.data_presensi
                              .special_allowance_summary_rev_employee_nip
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">Nama</label>
                    <Col md="9">
                      {this.state.data_presensi ? (
                        <>
                          {this.state.data_presensi
                            .special_allowance_summary_rev_employee_full_name !==
                            "" &&
                            this.state.data_presensi
                              .special_allowance_summary_rev_employee_full_name !==
                            null
                            ? this.state.data_presensi
                              .special_allowance_summary_rev_employee_full_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">
                      Jabatan
                    </label>
                    <Col md="9">
                      {this.state.data_presensi ? (
                        <>
                          {this.state.data_presensi
                            .current_position_name_new !== "" &&
                            this.state.data_presensi.current_position_name_new !==
                            null
                            ? this.state.data_presensi.current_position_name_new
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">
                      SKP Sebelum
                    </label>
                    <Col md="9">
                      {this.state.data_presensi ? (
                        <>
                          {this.state.data_presensi
                            ? this.state.data_presensi
                              .special_allowance_summary_rev_skp
                              ? this.state.data_presensi
                                .special_allowance_summary_rev_skp
                              : 0.00
                            : 0.00}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  {/* <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      Penilaian Pimpinan Revisi <span className="text-danger">*</span>
                    </Label>
                    <Col md="6">


                      <AvField
                        validate={{ required: { value: true } }}
                        name="special_allowance_summary_rev_skp"
                        type="number"
                      />
                    </Col>
                  </Row> */}
                  <Row className="mb-3">
                    <label
                      htmlFor="hasilkerja"
                      className="col-md-3 col-form-label"
                    >
                      Hasil Kerja <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name={`hasilkerja`}
                        errorMessage="Pilih Penilaian"
                        options={this.state.hasilperilakuOption}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Penilaian"
                        defaultValue={(this.state.data_presensi && this.state.data_presensi.special_allowance_summary_rev_work_result) ? this.state.data_presensi.special_allowance_summary_rev_work_result : ''}
                      // isLoading={this.state.hasilperilakuOption}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="perilakukerja"
                      className="col-md-3 col-form-label"
                    >
                      Perilaku Kerja <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name={`perilakukerja`}
                        errorMessage="Pilih Penilaian"
                        options={this.state.hasilperilakuOption}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Penilaian"
                        defaultValue={(this.state.data_presensi && this.state.data_presensi.special_allowance_summary_rev_work_behavior) ? this.state.data_presensi.special_allowance_summary_rev_work_behavior : ''}
                      // isLoading={this.state.hasilperilakuOption}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="hasilakhir"
                      className="col-md-3 col-form-label"
                    >
                      Hasil Akhir <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name={`hasilakhir`}
                        errorMessage="Pilih Penilaian"
                        options={this.state.optcriteria}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Penilaian"
                      // isLoading={this.state.optcriteria}
                      />
                    </Col>
                  </Row>
                </Fragment>
              )}
            </ModalBody>
            {this.state.loadingDetail === false &&
              this.state.data_periode.period_special_allowance_revision_status ==
              0 ? (
              <ModalFooter>
                <Button color="primary" type="submit">
                  Submit
                </Button>{" "}
                <Button onClick={() => this.toggleModalSkp()}>Cancel</Button>
              </ModalFooter>
            ) : null}
          </AvForm>
        </Modal>
        <Modal
          size="xl"
          isOpen={this.state.updatePenilaianUuid !== null ? true : false}
          toggle={() => this.toggleModalPenilaian()}
        >
          <ModalHeader toggle={() => this.toggleModalPenilaian()}>
            {this.state.detailPenilaianUuid != null ? "Detail" : "Ubah"} Penilaian
          </ModalHeader>
          <AvForm
            className="needs-validation"
            onValidSubmit={(e, values) => this.handlerOnSubmitPenilaian(e, values)}
          >
            <ModalBody>
              {(
                <Fragment>
                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">
                      Periode
                    </label>
                    <Col md="9">
                      {this.state.data_periode ? (
                        <>
                          {this.state.data_periode
                            .period_special_allowance_revision_periode !== "" &&
                            this.state.data_periode
                              .period_special_allowance_revision_periode !== null
                            ? this.state.data_periode
                              .period_special_allowance_revision_periode
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">Nip</label>
                    <Col md="9">
                      {this.state.data_presensi ? (
                        <>
                          {this.state.data_presensi
                            .special_allowance_summary_rev_employee_nip !==
                            "" &&
                            this.state.data_presensi
                              .special_allowance_summary_rev_employee_nip !== null
                            ? this.state.data_presensi
                              .special_allowance_summary_rev_employee_nip
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">Nama</label>
                    <Col md="9">
                      {this.state.data_presensi ? (
                        <>
                          {this.state.data_presensi
                            .special_allowance_summary_rev_employee_full_name !==
                            "" &&
                            this.state.data_presensi
                              .special_allowance_summary_rev_employee_full_name !==
                            null
                            ? this.state.data_presensi
                              .special_allowance_summary_rev_employee_full_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">
                      Jabatan
                    </label>
                    <Col md="9">
                      {this.state.data_presensi ? (
                        <>
                          {this.state.data_presensi
                            .current_position_name_new !== "" &&
                            this.state.data_presensi.current_position_name_new !==
                            null
                            ? this.state.data_presensi.current_position_name_new
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-1">
                    <label className="col-md-3 col-form-label pt-0">
                      Penilaian Pimpinan Sebelum
                    </label>
                    <Col md="9">
                      {this.state.data_presensi ? (
                        <>
                          {this.state.data_presensi
                            ? this.state.data_presensi
                              .special_allowance_summary_rev_penilaian_pimpinan
                              ? this.state.data_presensi
                                .special_allowance_summary_rev_penilaian_pimpinan
                              : 0.00
                            : 0.00}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "100%", height: "15px" }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  {/* <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      Penilaian Pimpinan Revisi <span className="text-danger">*</span>
                    </Label>
                    <Col md="6">


                      <AvField
                        validate={{ required: { value: true } }}
                        name="special_allowance_summary_rev_penilaian_pimpinan"
                        type="number"
                      />
                    </Col>
                  </Row> */}

                  <Table className="table table-striped table-bordered">
                    {this.state.loadingTable === false ? (
                      this.state.listComponents.length > 0 ? (
                        this.state.listComponents.map((data, index) => {
                          if (data.assessment_component_type == 1) {
                            number = 0;
                            return (
                              <thead className="table-primary">
                                <tr style={{ border: "1px solid #c8cce1" }}>
                                  <th
                                    className="text-center align-middle"
                                    width="5%"
                                  >
                                    No
                                  </th>
                                  <th
                                    className="text-center align-middle"
                                    width="70%"
                                  >
                                    {data.assessment_component_name}
                                  </th>
                                  <th
                                    className="text-center align-middle"
                                    width="25%"
                                  >
                                    Nilai{" "}
                                    <i
                                      id="info"
                                      className="fa fa-info-circle fa-lg"
                                    ></i>
                                    <Tooltip
                                      className="text-left"
                                      style={this.state.tooltipStyle}
                                      arrowClassName="custom-arrow"
                                      placement="right"
                                      isOpen={this.state["info"]}
                                      target="info"
                                      toggle={() => {
                                        this.setState({
                                          ["info"]: !this.state["info"],
                                        });
                                      }}
                                    >
                                      {this.state.listComponents.length > 0
                                        ? this.state.listCriteria.map(
                                          (criteria, i) => (
                                            <>
                                              {criteria.label} :{" "}
                                              {criteria.tooltip} <br></br>
                                            </>
                                          )
                                        )
                                        : ""}
                                    </Tooltip>
                                    <Col md="12">
                                      <AvRadioGroup
                                        name={`parent_${data.special_allowance_detail_index}`}
                                        // required
                                        errorMessage="Pilih salah satu"
                                        value={
                                          this.state.criteriaSelected[index]
                                        }
                                        onClick={(e) =>
                                          this.handleChangeParent(
                                            data.special_allowance_detail_index,
                                            index,
                                            e
                                          )
                                        }
                                      >
                                        <AvField
                                          name={`hiddenparent_${data.special_allowance_detail_index}`}
                                          type="hidden"
                                          className="form-control"
                                          validate={{
                                            required: { value: false },
                                          }}
                                          errorMessage="Pilih Kategori"
                                        />

                                        {this.state.listCriteria.map(
                                          (criteria, i) => (
                                            <div
                                              key={i}
                                              className="form-check-inline"
                                            >
                                              <label>
                                                <AvRadio
                                                  label={criteria.label}
                                                  value={criteria.value}
                                                />
                                              </label>
                                            </div>
                                          )
                                        )}
                                      </AvRadioGroup>
                                    </Col>
                                  </th>
                                </tr>
                              </thead>
                            );
                          } else if (data.assessment_component_type == 2) {
                            number = number + 1;
                            return (
                              <tbody>
                                <tr
                                  key={`tr_tunkin_${index}`}
                                  style={{ border: "1px solid #c8cce1" }}
                                >
                                  <td className="text-center">{number}</td>
                                  <td className="text-left">
                                    {data.assessment_component_name}
                                  </td>
                                  <td className="text-center">
                                    <Col md="12">
                                      <AvRadioGroup
                                        name={`select_${data.assessment_component_uuid}`}
                                        required
                                        errorMessage="Pilih salah satu"
                                        value={
                                          this.state.criteriaSelected[index]
                                        }
                                        onClick={(e) =>
                                          this.handleChange(index, e)
                                        }
                                      >
                                        <AvField
                                          name={`component_${data.assessment_component_uuid}`}
                                          type="hidden"
                                          className="form-control"
                                          validate={{
                                            required: { value: true },
                                          }}
                                          id={`component_${data.assessment_component_uuid}`}
                                          value={
                                            this.state.criteriaSelected[index]
                                          }
                                          errorMessage="Pilih Kategori"
                                        />
                                        {this.state.loadingTable === false ? (
                                          this.state.listComponents.length >
                                            0 ? (
                                            this.state.listCriteria.map(
                                              (criteria, i) => (
                                                <div
                                                  key={i}
                                                  className="form-check-inline"
                                                  id={`criteria-${data.assessment_component_uuid}-${criteria.value}`}
                                                >
                                                  <label
                                                    htmlFor={`radio_${data.assessment_component_uuid}_${criteria.value}`}
                                                  >
                                                    {/* Wrap AvRadio within a label */}
                                                    <AvRadio
                                                      label={criteria.label}
                                                      value={criteria.value}
                                                      id={`radio_${data.assessment_component_uuid}_${criteria.value}`}
                                                    />
                                                  </label>
                                                  <Tooltip
                                                    style={
                                                      this.state.tooltipStyle
                                                    }
                                                    arrowClassName="custom-arrow"
                                                    placement="right"
                                                    isOpen={
                                                      this.state[
                                                      `criteria-${data.assessment_component_uuid}-${criteria.value}`
                                                      ]
                                                    }
                                                    target={`criteria-${data.assessment_component_uuid}-${criteria.value}`}
                                                    toggle={() => {
                                                      this.setState({
                                                        [`criteria-${data.assessment_component_uuid}-${criteria.value}`]:
                                                          !this.state[
                                                          `criteria-${data.assessment_component_uuid}-${criteria.value}`
                                                          ],
                                                      });
                                                    }}
                                                  >
                                                    {criteria.tooltip}
                                                  </Tooltip>
                                                </div>
                                              )
                                            )
                                          ) : (
                                            <tr
                                              style={{
                                                border: "1px solid #c8cce1",
                                              }}
                                            >
                                              <td
                                                colSpan="17"
                                                className="text-center"
                                              >
                                                Tidak Ada Data
                                              </td>
                                            </tr>
                                          )
                                        ) : (
                                          <tr
                                            style={{
                                              border: "1px solid #c8cce1",
                                            }}
                                          >
                                            <td
                                              colSpan="17"
                                              className="text-center"
                                            >
                                              <Spinner
                                                className="m-2"
                                                color="primary"
                                              />
                                            </td>
                                          </tr>
                                        )}
                                      </AvRadioGroup>
                                    </Col>
                                  </td>
                                </tr>
                              </tbody>
                            );
                          }
                        })
                      ) : (
                        <tr style={{ border: "1px solid #c8cce1" }}>
                          <td colSpan="17" className="text-center">
                            Tidak Ada Data
                          </td>
                        </tr>
                      )
                    ) : (
                      <tr style={{ border: "1px solid #c8cce1" }}>
                        <td
                          colSpan="17"
                          className="text-center"
                          style={{ position: "relative" }}
                        >
                          <div
                            className="md-12 text-center"
                            style={{
                              alignItems: "center",
                              left: "50%",
                            }}
                          >
                            <Spinner
                              className="text-center"
                              color="primary"
                            />
                            <div>Memuat Data</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </Table>

                </Fragment>
              )}
            </ModalBody>
            {this.state.loadingDetail === false &&
              this.state.data_periode.period_special_allowance_revision_status ==
              0 ? (
              <ModalFooter>
                <Button color="primary" type="submit">
                  Submit
                </Button>{" "}
                <Button onClick={() => this.toggleModalPenilaian()}>Cancel</Button>
              </ModalFooter>
            ) : null}
          </AvForm>
        </Modal>


        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={
            this.state.confirmInfo
              ? this.state.confirmInfo
              : "Apakah anda yakin?"
          }
          loadingTitle="Mengambil data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={
              `/kepegawaian/revisi_keuangan.html?pegawai&uuid=` +
              this.props.uuid
            }
          />
        ) : null}
        {this.state.is_grade ? (
          <Redirect
            to={`/kepegawaian/revisi_tunjangan_khusus.html?update_grade&revision_uuid=${this.queryParams.get(
              "revision_uuid"
            )}&employee_uuid=${this.props.employee_uuid}`}
          />
        ) : null}
        {this.state.is_koreksi_kehadiran ? (
          <Redirect
            to={
              `/izinpegawai/koreksikehadiran.html?create&is_revisi=1&pegawai_uuid=` +
              this.queryParams.get("employee_uuid") +
              `&period_revision_uuid=` +
              this.queryParams.get("period_uuid")
            }
          />
        ) : null}
        {this.state.is_dinas ? (
          <Redirect
            to={
              `/izinpegawai/dinas.html?create&is_revisi=1&pegawai_uuid=` +
              this.queryParams.get("employee_uuid") +
              `&period_revision_uuid=` +
              this.queryParams.get("period_uuid")
            }
          />
        ) : null}
        {this.state.is_cuti ? (
          // set current employee uuid selected

          <Redirect
            to={
              `/izinpegawai/cuti.html?create&is_revisi=1&pegawai_uuid=` +
              this.queryParams.get("employee_uuid") +
              `&period_revision_uuid=` +
              this.queryParams.get("period_uuid")
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
